import { defaults } from '@/api'

/**
 * Un appel écrit hors du client généré passe par `defaults.fetch`, comme lui : la veille de fin de session « en tant
 * que » s'y branche (et Sentry, en production). Un `fetch` direct lui échappait (recette du 29/10/2026).
 */
export const apiFetch: typeof fetch = (input, init) =>
  (defaults.fetch ?? fetch)(input, init)
